<template>
  <main class="mx-auto max-w-[80ch] [&>*]:my-4">
    <h1>Quick and easy calibration tool for Tasmota</h1>
    <p>
      This tool will help you to recalibrate your Tasmota device.<br/>
      It will calculate the current based on the power and voltage you enter.<br/>

      Once you've entered the values, you can copy the command to your clipboard and paste it into the Tasmota
      console.
    </p>

    <div class="max-w-lg mx-auto grid grid-cols-3 gap-1">
      <div class="form-field">
        <label class="form-label">Voltage (V)</label>
        <input v-model.number="voltage" class="input" max="1_000" min="0" type="number"/>
      </div>
      <div class="form-field">
        <label class="form-label">Power (W)</label>
        <input v-model.number="power" class="input" max="10_000" min="0" type="number"/>
      </div>
      <div class="form-field">
        <label class="form-label">Current (A)</label>
        <input v-model="currentDisplay" class="input" readonly type="number"/>
      </div>

      <div class="form-field col-span-3">
        <label class="form-label">Command</label>
        <SassyError v-if="isError"/>
        <div v-else class="btn-group !max-w-full !w-full !flex-nowrap">
          <input v-model="command" class="input !max-w-full" readonly/>
          <button class="btn btn-outline" @click="copy">📋</button>
        </div>
      </div>
    </div>

    <p>
      The full procedure is described in the Tasmota docs:
      <a href="https://tasmota.github.io/docs/Power-Monitoring-Calibration/">
        Tasmota Docs / Features / Power Monitoring Calibration
      </a>

      You will need a a known wattage load with a power factor as close to 1 as possible (e.g., a resistive load) for
      best results.<br/>
      This could be a light bulb, a heater, or a kettle.

    </p>

    <ol class="list-decimal ml-[1em]">
      <li>Connect the load (e.g., a 60W incandescent light bulb) to your device</li>
      <li>Open the web UI browser windows for your power monitoring device</li>
      <li>Turn on your load, and wait a few seconds for the readings to stabilise</li>
      <li>Enter the expected voltage and power values into the form above</li>
      <li>Copy the command from the form below and paste it into the Tasmota console</li>
    </ol>

  </main>
</template>
<script lang="ts" setup>

const {$toast: toast} = useNuxtApp();

const voltage = ref(230);
const power = ref(60);
const current = computed(() => power.value / voltage.value);
const currentDisplay = computed(() => current.value.toFixed(2));

const isError = computed(() => current.value <= 0 || current.value <= 0);
const command = computed(() => `Backlog PowerSet ${power.value}; VoltageSet ${voltage.value}; CurrentSet ${(current.value * 1000).toFixed(2)};`);

const copy = () => {
  navigator.clipboard.writeText(command.value);
  toast.success('Copied to clipboard');
};
</script>
